export const errorCodes = {
  'field.firstName.invalid': 'Имя не должно содержать недопустимые символы',
  'field.name.empty': 'Не указано название', // название адреса? или еще что-то?
  'field.street.empty': 'Не указано название улицы',
  'field.house.empty': 'Не указан номер дома',
} as const;
